































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { subscriptionState } from '../../../stores/subscription'
import PremiumService from '../../../../api/v2/models/pre_service'

@Component
export default class ChangePlan extends Vue {
  premiumServicesToChangePlan: PremiumService[] = []
  isLoading = true

  created() {
    this.getPremiumServicesToChangePlan()
  }
  
  getPremiumServicesToChangePlan() {
    subscriptionState.getPremiumServicesToChangePlan(this.$route.params.subscriptionId as any).then((response) => {
      if (response) {
        this.premiumServicesToChangePlan = response
        this.isLoading = false
      }
    })
  }

  localNumber(number: number) {
    return new Intl.NumberFormat("ja-JP").format(number)
  }
}
